const faq  = () => {
  const tabs = document.querySelector('.js-faq-tabs');
  const tabgroup = document.querySelectorAll('.js-faq-tgr');
  const tabgroupitem = document.querySelector('.js-faq-tgi');
  const tabitem = document.querySelectorAll('.js-faq-tab-item');
  const faqquestion = document.querySelectorAll('.js-faq-q');
  const faqanswer = document.querySelectorAll('.js-faq-a') as any;
  let lastActiveTab = null as any;

  if (tabitem) {
    tabitem.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        if (tab === lastActiveTab) return;
  
        tab.classList.add('active');
        lastActiveTab?.classList.remove('active');
        lastActiveTab = tab;

        tabgroupitem?.classList.toggle('active');
        tabgroup.forEach((group) => {
          group.classList.remove('active');
        });

        if (tabgroup[index]) {
          tabgroup[index].classList.add('active');
        }

        tabs?.classList.toggle('active');
      });
    });
  }

  if (faqquestion) {
    for (let i = 0; i < faqquestion.length; i++) {
      if (faqquestion[i]) {
        faqquestion[i].addEventListener('click', () => {
          faqquestion[i].classList.toggle('active');
          faqanswer[i].classList.toggle('active');
        });
      }
    }
  }
};

export default faq;